/* eslint-disable @typescript-eslint/indent */
import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import StickyHeader from 'modules/Common/Components/StickyHeader';
import StickyHeaderContent from 'modules/Common/Components/StickyHeaderContent';
import { PageParams } from 'constants/interfaces/GlobalInterfaces';
import SkeletonCustom from 'modules/Common/Skeleton/SkeletonCustom';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import GlobalAntButton from 'modules/Common/Components/GlobalAntButton';
import { FORM_HANDLER_USER_GUIDE } from './constants';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  .header-buttons {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .global-btn-style:hover {
    opacity: 0.7;
  }
`;

const SettingStickyHeader: React.FC = () => {
  const { page } = useParams<PageParams>();
  const formSummaryLoading = useSelector((state: RootState) => state.forms.selectedForm.loading);
  //Add other loading state dependencies here using OR '||' operator
  const loading = false; //formSummaryLoading;
  const popoverText = (
    <p style={{ marginBottom: '0' }}>
      Seamlessly integrate external forms with xiQ Workbench. Capture valuable data, track leads, and automate your marketing efforts with ease.{' '}
      <a href={FORM_HANDLER_USER_GUIDE} target="_blank" style={{ fontStyle: 'italic', textDecoration: 'underline', fontWeight: '400' }}>
        view guide
      </a>
    </p>
  );

  const headerShowBack: { [key: string]: any } = {
    forms: true,
    groups: true,
    default: false,
  };

  const headerLabels: { [key: string]: any } = {
    forms: 'Form Handler',
    groups: 'Sales Xelerator Groups',
    default: 'Settings',
  };

  return (
    <Wrapper className="setting-sticky-header">
      <StickyHeader>
        <div className="w-100 mb-[120px]">
          {loading ? (
            <SkeletonCustom height="40px" width="160px" diameter="8px" />
          ) : (
            <StickyHeaderContent
              showBack={headerShowBack[page ? page : 'default']}
              label={headerLabels[page ? page : 'default']}
              showInfoIcon
              infoText={popoverText}
            >
              {/* <div className="header-buttons">
                <GlobalAntButton
                  buttonType={'type'}
                  btnType={'link'}
                  disabled={false}
                  onClick={() => {}}
                  width={'max-content'}
                  bgColor="#fff"
                  color="#7E7E7E"
                  fontSize="16px"
                  border="1px solid #DADADA"
                  borderRadius="8px"
                  btnText="Forms"
                />
                <GlobalAntButton
                  buttonType={'type'}
                  btnType={'link'}
                  disabled={false}
                  onClick={() => {}}
                  width={'max-content'}
                  bgColor="#DEF6E6"
                  color="#1EC252"
                  fontSize="16px"
                  border="1px solid #DADADA"
                  borderRadius="8px"
                  btnText="Form Handler"
                />
              </div> */}
            </StickyHeaderContent>
          )}
        </div>
      </StickyHeader>
    </Wrapper>
  );
};

export default SettingStickyHeader;
